"use client";
import React, { useState, useRef, useEffect } from "react";
import styles from "./LanguageSelector.module.css";
import down_img from "@/assets/Icon/Down_Icon.png";
import languageCode from "@/DB/LanguageCodeDB.json";
import i18n from "i18next";
import local from "@/DB/LanguageDB.json";
import Image from "next/image";

const languageKey = Object.keys(local);

// Unity에서 넘겨주는 코드 → i18n 언어키 매핑 (예시는 추측입니다)
const unityLangMap = {
  "0": languageKey[0], // ko
  "1": languageKey[1], // en
  "2": languageKey[2], // jp
  "3": languageKey[3], // cn
};

const LanguageSelector = ({ isHover }) => {
  const wrapperRef = useRef(null);

  const options = languageCode.map((value, index) => ({
    value: languageKey[index],
    label: value,
  }));

  const [selected, setSelected] = useState(i18n.language);
  const [isLanguageHover, setIsLanguageHover] = useState(false);
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);

  const changeLanguage = (lang) => {
    setIsLanguageOpen(false);
    i18n.changeLanguage(lang);
  };

  // ✅ i18n 이벤트 구독은 effect 안에서 한 번만
  useEffect(() => {
    const handler = (lng) => {
      setSelected(lng);
    };
    i18n.on("languageChanged", handler);
    return () => {
      i18n.off("languageChanged", handler);
    };
  }, []);

  // ✅ 컴포넌트가 처음 켜질 때, URL 쿼리에서 lang 읽어서 언어 세팅
  useEffect(() => {
    if (typeof window === "undefined") return;

    const params = new URLSearchParams(window.location.search);
    const unityLang = params.get("lang"); // Unity에서 넘겨준 값 (예: "0", "1"...)

    if (!unityLang) return;

    const mapped = unityLangMap[unityLang];
    if (!mapped) return;

    if (mapped !== i18n.language) {
      i18n.changeLanguage(mapped);
    }
  }, []);

  // 바깥 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !(wrapperRef.current).contains(event.target)) {
        setIsLanguageOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const currentOption = options.find((item) => item.value === selected) ?? options[0];

  return (
    <div ref={wrapperRef} className={styles.lang__page}>
      <div
        className={styles.container}
        onClick={() => {
          setIsLanguageOpen(!isLanguageOpen);
        }}
      >
        <div
          className={styles.select__language}
          onMouseEnter={() => setIsLanguageHover(true)}
          onMouseLeave={() => setIsLanguageHover(false)}
        >
          <span className={`${styles.lang__text} ${isHover ? styles.hover : ""}`}>
            {currentOption.label}
          </span>
          <div className={styles.lang__down__btn}>
            <Image
              src={down_img}
              className={`${styles.lang__down__btn__image} ${isHover ? styles.hover : ""} ${
                isLanguageOpen ? styles.open : ""
              }`}
              alt="selector icon"
            />
          </div>
        </div>
        <span
          className={`${styles.activeLine} ${
            isLanguageHover ? styles.open : ""
          } ${isHover ? styles.hover : ""}`}
        />
        <div
          className={`${styles.lan__select__box} ${
            isLanguageOpen ? styles.open : styles.hidden
          } ${isHover ? styles.hover : ""}`}
          onMouseEnter={() => setIsLanguageHover(true)}
          onMouseLeave={() => setIsLanguageHover(false)}
        >
          {options.map((item, index) => (
            <span
              key={index}
              className={`${isHover ? styles.lan__select__box__detail__hover : styles.lan__select__box__detail} ${
                selected === item.value ? styles.active : ""
              }`}
              onClick={() => {
                changeLanguage(item.value);
              }}
            >
              {item.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
